export enum FiTimeUnitType {
    Second,
    Minute,
    Hour,
    Day,
    Month,
    Year,
}
